module.exports = __webpack_public_path__ + "img/tiktok.9c5da32f.svg";